<template>
  <div v-if="showPage" style="background: white">
    <div class="home-banner-box"></div>
    <div class="lhcz-intro-box">
      <img
        class="img-box"
        src="../assets/homeViewImg/lhcz_intro_img.png"
        alt=""
      />
      <div class="content-box">
        <div class="text-block1">联合创展</div>
        <div class="text-block2">Company Profile</div>
        <div class="text-block3">
          帮助企业优化资源配置，降低运维成本实现全流程、全生命周期的精细化管理——只做到最好
        </div>
        <div class="text-block4">
          <p>
            联合创展成立于2010年3月，致力于装饰装修、智能智慧系统、工业自动化
            及工程设计等方面为一体的专业性公司。公司拥有四项专业资质及安全生产
            许可证。
          </p>
          <p>
            联合创展拥有行业优秀的专业队伍。坚持以人为本，鼓励员工充分发挥自己的才智和潜能，并为员工创造一个优良公平竞争的工作环境及施展才能的机会适才其用，广纳贤才。联合创展的员工以活跃的思维方式，勤奋的工作态度，不断进取的开拓精神，积极协作的团队意识，良性推动企业发展
          </p>
          <p>
            公司成立至今，公司坚持用"品质，唯美，尊重，树人"的文化提升核心竞争力，一贯恪守“诚信、务实、求精、创新”的企业精神，专业的设计、科学的管理、规范的施工、全身心的服务，公司力求达到:设计零缺憾，施工零缺点，材料零抱怨，品质零投诉！以完美的设计，严格的管理，精堪的工艺，真诚的服务。
          </p>
        </div>
        <div class="btn-box" @click="goToNavigate(1)">查看详情</div>
      </div>
    </div>
    <div class="main-business-box">
      <div class="title-box">主营业务</div>
      <div class="text-box">Main Business</div>
      <div class="ul-box">
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img1.png" alt="" />
        </div>
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img2.png" alt="" />
        </div>
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img3.png" alt="" />
        </div>
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img4.png" alt="" />
        </div>
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img5.png" alt="" />
        </div>
        <div class="li-box">
          <img src="../assets/homeViewImg/m_b_img6.png" alt="" />
        </div>
      </div>
    </div>
    <div class="project-case-box">
      <div class="title-box">工程案例</div>
      <div class="text-box">Qualification Certificate</div>
      <div class="section-box">
        <div class="block1">
          <div
            v-for="item in pCaseItems"
            :key="item.id"
            class="text-item-box"
            :class="{ 'is-active': pCaseNum === item.id }"
            @click="activeBtn(item.id)"
          >
            {{ item.text }}
          </div>
        </div>
        <div class="block2">
          <img
            class="img-item-box"
            v-for="item in [...Array(16).keys()].slice(pCaseNum, pCaseNum + 3)"
            :key="item"
            :src="
              require('../assets/homeViewImg/project_case_img' +
                (item + 1) +
                '.png')
            "
          />
        </div>
        <div class="block3" @click="goToNavigate(2)">
          <span>查看更多</span>
          <img src="../assets/homeViewImg/project_case_icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="course-box">
      <div class="title-box">发展历程</div>
      <div class="text-box">Development History</div>
    </div>
    <div class="certificate-box">
      <div class="title-box">资质证书</div>
      <div class="text-box">Qualification Certificate</div>
      <div class="ul-box">
        <div class="li-box">
          <el-image
            class="img-block"
            :src="require('../assets/qualification1.jpg')"
            :preview-src-list="[require('../assets/qualification1.jpg')]"
          />
          <span>建筑业企业资质证书</span>
        </div>
        <div class="li-box">
          <el-image
            class="img-block"
            :src="require('../assets/qualification3.jpg')"
            :preview-src-list="[require('../assets/qualification3.jpg')]"
          />
          <span>工程设计资质证书</span>
        </div>
        <div class="li-box">
          <el-image
            class="img-block"
            :src="require('../assets/qualification4.jpg')"
            :preview-src-list="[require('../assets/qualification4.jpg')]"
          />
          <span>软件著作权登记证书</span>
        </div>
        <div class="li-box">
          <el-image
            class="img-block"
            :src="require('../assets/qualification5.png')"
            :preview-src-list="[require('../assets/qualification5.png')]"
          />
          <span>监控直方图熵专利证书</span>
        </div>
      </div>
    </div>

    <!-- <el-carousel
      class="hidden-xs-only"
      height="1000px"
      style="background: white"
      indicator-position="none"
      :autoplay="false"
    >
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="item active">
          <img style="width: 100%" :src="getAssetsImages(item)" alt="" />
        </div>

        <div class="carousel-text text-c">
          <div class="carousel-title hidden-xs-only">联众合心 创意展放</div>
          <div class="visible-xs xs-carousel-title">联众合心 创意展放</div>
          <p class="carText-con">
            <br />互联网+科技/创业/智能化/家装平台行业产业聚合
          </p>
        </div>
      </el-carousel-item>
    </el-carousel> -->

    <!-- <el-carousel
      class="visible-xs"
      height="300px"
      style="background: white"
      indicator-position="none"
      :autoplay="false"
    >
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="item active">
          <img style="width: 100%" :src="getAssetsImages(item)" alt="" />
        </div>

        <div class="carousel-text text-c">
          <div class="carousel-title hidden-xs-only">联众合心 创意展放</div>
          <div class="visible-xs xs-carousel-title">联众合心 创意展放</div>
          <p class="carText-con">
            <br />互联网+科技/创业/智能化/家装平台行业产业聚合
          </p>
        </div>
      </el-carousel-item>
    </el-carousel> -->

    <!-- <div
      class="bg-f7"
      style="margin-top: 40px; margin-bottom: 100px; background: white"
    >
      <div class="area-title" style="margin-bottom: 10px">
        <h2>关于联合创展</h2>
        <p class="carSubtitle" style="margin-top: 10px">联众合心 创意展放</p>
      </div>
      <div class="about-text">
        <div style="font-size: 26px">
          浙江联合创展科技股份有限公司，成立于2010年3月，注册资金988万元，2014年2月完成股改。是由国内资深策划师、设计师、平面设计师和专业技术人员组成，致力于装饰装修工程、机电智能化、住宅集成设计及施工为一体的专业性公司。
        </div>
      </div>
      <img
        src="../../public/img/homeImg.png"
        alt=""
        style="width: 100%; height: auto; margin-top: 110px"
      />
    </div> -->

    <!-- <div class="bg-f7" style="height: 760px; text-align: center">
      <div class="area-title" style="padding-top: 90px">
        <h2>业务领域</h2>
        <p class="carSubtitle area-subtitle" style="margin-top: 10px">
          装饰装修、电子与智能化、工业自动化升级、室内专项设计<br />机电安装、软件开发等
        </p>
      </div>
      <div class="area_img">
        <img src="@/assets/Home/images/home/icon/areaImg1.png" />
        <img src="@/assets/Home/images/home/icon/areaImg2.png" />
      </div>
    </div> -->

    <!--end 业务领域-->
    <!--start 公司视频-->

    <!--end 公司视频-->
    <!--start 关于我们
    <div class="homeAbout">
        <div class="homeAboutCon">
            <h3>联合创展----荣装网家装o2o平台</h3>
            <p>浙江联合创展科技股份有限公司 ，成立于2010年3月。2015年12月联合创展进行企业可持续发展方向调整，由传统家装企业转型至互联网企业，互联网聚合是在互联网+基础上建立的整合行业资源，解决装修行业“不透明、价格贵”的一项重要创新，荣装网是浙江联合创展科技股份有限公司旗下泛家装生态聚合平台品牌。荣装网致力于用互联网思维及技术，着重服务意识，第三方监理、智能在线管理等服务,正在建立一套完善的全国客户监理中心。
                <br /> 传统装饰行业面临变革.家装市场容量过万亿。
            </p>
            <a href="/index.php/index/about.html" class="more">了解更多</a>
        </div>
    </div>
    关于我们-->

    <!-- <div class="_content project">
      <h2 class="hidden-xs">集团项目</h2>
      <h2 class="visible-xs" style="width: 100vw;">集团项目</h2>

      <div class="project-content row  ">
        <div class="item col-sm-4 col-xs-12">
          <div class="img-container">
            <img src="@/assets/Home/images/home/project1.png" alt="">
          </div>

          <div class="project-name ">
            共同富裕
          </div>
        </div>
        <div class="item col-sm-4 col-xs-12">
          <div class="img-container">
            <img src="@/assets/Home/images/home/project3.jpeg" alt="">
          </div>
          <div class="project-name  ">
            荣装网服务中心
          </div>
        </div>
        <div class="item col-sm-4 col-xs-12">
          <div class="img-container ">
            <img src="@/assets/Home/images/home/project2.jpeg" alt="">
          </div>
          <div class="project-name  ">
            精装修业务
          </div>
        </div>
      </div>
    </div> -->
    <!--start 新闻资讯-->
    <!-- <div class="_content homeNews">
      <div class="hidden-xs">
        <h2 class="">新闻资讯</h2>
        <p class="carSubtitle m-b-xxl  ">每时每刻了解最新动态</p>
      </div>
      <div class="visible-xs" style="width: 100vw;">
        <h2 class="">新闻资讯</h2>
        <p class="carSubtitle m-b-xxl  ">每时每刻了解最新动态</p>
      </div>
      <div class="_content newsCon" id="gsdt">
        <div class="row">
          <div class="col-sm-4 col-xs-12" v-for="(item,index) in newsList" :key="index">
            <router-link :to="{path:'news/newsDetail',query:{id:item.id}}" target="_blank">
              <img :src="item.img" alt="">
              <div class="programmeCon">
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ item.showTime }}</div>
                <div class="more">
                  <i class="fa fa-long-arrow-right"></i>更多 / MORE
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div> -->
    <!--end 新闻资讯-->
    <!--start 友情链接-->
    <!--    <div class="bg-f7">-->
    <!--      <div class="_content padder-v link">-->
    <!--        友情链接：-->
    <!--        <a href="https://www.rongzw.com" class="m-xxs" target="_blank">荣装网</a>-->
    <!--        <a href="http://www.yihonge.com" class="m-xxs" target="_blank">一红信息技术</a>-->
    <!--        <a href="http://www.ehonge.com/" class="m-xxs" target="_blank">易空间</a>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--end 友情链接-->

    <!--    <el-pagination-->

    <!--        :pager-count="count"-->
    <!--        layout="prev, pager, next"-->

    <!--        @current-change="getNewsList"-->
    <!--    />-->
  </div>
</template>

<script setup>
import apiService from '@/api/index';
import { ref, onMounted, reactive } from "vue";
import '@/assets/Home/vendor/jquery/jquery-1.11.3.min.js'
import { useRouter } from 'vue-router'

const router = useRouter()
const showPage = ref(false)
const newsList = ref([])
const list = ref([
  '1.jpg',
  '2.jpg',
  '3.jpg'
])
const pCaseNum = ref(1)
const pCaseItems = ref([
  { id: 1, text: '丽水职业技术学院艺术楼 （提升工程）' },
  { id: 3, text: '浙江旺荣半导体有限公司 一研发工程中心装饰工程' },
  { id: 6, text: '中铁办公楼装修工程' },
  { id: 9, text: '庆元廊桥博物馆' },
  { id: 12, text: '丽水未来社区精装修' }
])

const baseUrl = process.env.BASE_URL

showPage.value = true
// setTimeout(()=>{
//   showPage.value=true
// },50)
getNewsList(13, 1)
//type=1是公司动态，2是行业动态
//category_id 13=公司动态，14=装饰信息，15=家装案例，16=设计规划，19=科技网络
function getNewsList(category_id, type) {
  apiService.getNewsList({ category_id, page_size: type == 1 ? 3 : 6 }).then(res => {
    res.data.list = res.data.list.map(item => {
      item.showTime = item.showTime.split(' ')[0]
      return item
    })
    if (type == 1) {
      newsList.value = res.data.list
    }
  })
}

const getAssetsImages = (name) => {
  return `${baseUrl}img/banner/${name}`;


}

const goToNavigate = (val) => {
  if (val === 1) {
    router.push('/about')
  } else if (val === 2) {
    router.push('/cooperation')
  }
}

const activeBtn = (val) => {
  pCaseNum.value = val
}


</script>


<style scoped lang="scss">
@import "@/assets/Home/css/font-awesome.min.css";
@import "@/assets/Home/css/fonts/otherfont/iconfont.css";
@import "@/assets/Home/vendor/bootstrap/bootstrap.min.css";
@import "@/assets/Home/css/app.css";
@font-face {
  font-family: "AbhayaLibre-ExtraBold-2";
  src: url("../assets/font/AbhayaLibre-ExtraBold-2.ttf");
}

.home-banner-box {
  width: 100%;
  height: 750px;
  background-image: url("../assets/homeViewImg/h_banner1.png");
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 1200px) {
  .home-banner-box {
    height: 520px;
  }
}
@media (max-width: 768px) {
  .home-banner-box {
    height: 320px;
  }
}
@media (max-width: 480px) {
  .home-banner-box {
    height: 250px;
  }
}

.lhcz-intro-box {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-image: url("../assets/homeViewImg/lhcz_intro_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column; /* 小屏默认垂直排列（图片在上，内容在下） */
  align-items: center; /* 小屏内容居中，提升视觉平衡 */
  gap: 25px; /* 小屏图片与内容间距，避免拥挤 */
  padding: 30px 15px 40px; /* 缩减上下内边距（原50px/35px），小屏更紧凑；左右加防贴边内边距 */
  box-sizing: border-box;

  // 图片区（顶部展示图）
  .img-box {
    width: 100%;
    max-width: 629px; /* 限制最大宽度，匹配原设计 */
    height: auto; /* 取消固定高度，自适应宽度保持比例 */
    max-height: 559px; /* 限制最大高度，避免小屏图片过高 */
    object-fit: cover; /* 确保图片填充容器，不拉伸变形 */
    border-radius: 8px; /* 小屏加圆角，提升质感（大屏可取消） */
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08); /* 轻微阴影，区分背景与图片 */
  }

  // 内容区（标题+英文副标题+简介+详情文本+按钮）
  .content-box {
    width: 100%;
    max-width: 530px; /* 限制最大宽度，避免大屏文本过宽（匹配原text-block3宽度） */
    color: #333;
    padding: 0 5px; /* 小屏加左右内边距，避免文本贴边 */

    // 中文标题（联合创展）
    .text-block1 {
      font-weight: 700;
      font-size: 26px; /* 小屏缩小字体（原32px），避免换行 */
      margin-top: 0; /* 小屏取消顶部margin，与图片间距靠父容器gap控制 */
      text-align: center; /* 小屏标题居中，强化视觉焦点 */
    }

    // 英文副标题（Company Profile）
    .text-block2 {
      font-weight: 700;
      font-size: 22px; /* 小屏缩小字体（原28px） */
      color: #999;
      margin: 8px 0 15px; /* 缩减间距（原12px/20px），小屏更紧凑 */
      font-family: AbhayaLibre-ExtraBold-2;
      text-align: center; /* 小屏英文标题居中，与中文标题呼应 */
    }

    // 核心简介（帮助企业优化资源配置...）
    .text-block3 {
      max-width: 100%; /* 取消固定宽度，自适应父容器 */
      font-size: 18px; /* 小屏缩小字体（原22px） */
      margin-bottom: 12px; /* 缩减底部间距（原16px） */
      text-align: center; /* 小屏核心简介居中，提升阅读焦点 */
      line-height: 1.6; /* 优化行高，避免文字拥挤 */
    }

    // 详情文本（公司成立时间+团队+理念...）
    .text-block4 {
      font-size: 14px; /* 小屏缩小字体（原15px） */
      color: #464646;
      line-height: 1.7; /* 优化行高，提升长文本可读性 */

      p {
        max-width: 100%; /* 取消固定宽度，自适应父容器 */
        margin-bottom: 12px; /* 增加段落间距，区分内容块 */
      }

      p:last-child {
        margin-bottom: 0; /* 清除最后一段底部间距，避免冗余 */
      }
    }
  }

  // 查看详情按钮
  .btn-box {
    width: 120px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    background: #3755f7;
    border-radius: 3px;
    color: white;
    font-size: 15px;
    margin-top: 18px; /* 缩减顶部间距（原20px），小屏更紧凑 */
    margin-left: auto;
    margin-right: auto; /* 小屏按钮居中，提升交互焦点 */
    transition: background 0.3s ease; /* 加过渡效果，提升交互体验 */

    &:hover {
      background: #2a44d7; /*  hover深色变化，强化交互反馈 */
    }
  }

  // --------------------------
  // 中屏（768px-1199px）：半横向布局，适配平板
  // --------------------------
  @media (min-width: 768px) and (max-width: 1199px) {
    flex-direction: row; /* 中屏横向排列（图片+内容） */
    flex-wrap: wrap; /* 避免极端中屏溢出，自动换行 */
    justify-content: center; /* 中屏整体居中 */
    gap: 30px; /* 增加图片与内容间距，比小屏宽松 */
    padding: 40px 20px 45px; /* 增加内边距，比小屏宽松 */

    .img-box {
      width: 45%; /* 图片占45%宽度 */
      max-height: 500px; /* 调整最大高度，适配中屏 */
      border-radius: 8px; /* 保留圆角，提升质感 */
    }

    .content-box {
      width: 45%; /* 内容占45%宽度 */
      max-width: none; /* 取消最大宽度限制，适配中屏 */
      padding: 0; /* 清除小屏内边距 */

      .text-block1 {
        font-size: 29px; /* 增大字体，接近原设计 */
        text-align: left; /* 恢复左对齐，符合阅读习惯 */
        margin-top: 10px; /* 恢复顶部margin，匹配原设计 */
      }

      .text-block2 {
        font-size: 25px; /* 增大字体，接近原设计 */
        margin: 10px 0 18px; /* 调整间距，接近原设计 */
        text-align: left; /* 恢复左对齐 */
      }

      .text-block3 {
        font-size: 20px; /* 增大字体，接近原设计 */
        margin-bottom: 14px; /* 调整间距 */
        text-align: left; /* 恢复左对齐 */
      }

      .text-block4 {
        font-size: 15px; /* 恢复原字体 */
      }
    }

    .btn-box {
      margin-top: 20px; /* 恢复原顶部间距 */
      margin-left: 0; /* 取消居中，恢复左对齐 */
      margin-right: auto;
    }
  }

  // --------------------------
  // 大屏（≥1200px）：还原原设计，左右分栏
  // --------------------------
  @media (min-width: 1200px) {
    flex-direction: row; /* 大屏横向排列 */
    justify-content: center; /* 整体居中，匹配原设计 */
    gap: 35px; /* 恢复原间距（原35px） */
    padding: 50px 0 35px; /* 恢复原内边距 */

    .img-box {
      width: 629px; /* 恢复原固定宽度 */
      height: 559px; /* 恢复原固定高度 */
      border-radius: 0; /* 清除圆角，还原原设计 */
      box-shadow: none; /* 清除阴影，还原原设计 */
    }

    .content-box {
      max-width: 530px; /* 恢复原最大宽度 */
      padding: 0; /* 清除内边距 */

      .text-block1 {
        font-size: 32px; /* 恢复原字体 */
        text-align: left; /* 恢复左对齐 */
        margin-top: 10px; /* 恢复原顶部margin */
      }

      .text-block2 {
        font-size: 28px; /* 恢复原字体 */
        margin: 12px 0 20px; /* 恢复原间距 */
        text-align: left; /* 恢复左对齐 */
      }

      .text-block3 {
        font-size: 22px; /* 恢复原字体 */
        max-width: 530px; /* 恢复原固定宽度 */
        margin-bottom: 16px; /* 恢复原间距 */
        text-align: left; /* 恢复左对齐 */
      }

      .text-block4 {
        font-size: 15px; /* 恢复原字体 */
        p {
          max-width: 530px; /* 恢复原固定宽度 */
        }
      }
    }

    .btn-box {
      margin-top: 20px; /* 恢复原顶部间距 */
      margin-left: 0; /* 恢复左对齐 */
      margin-right: auto;
    }
  }
}

.main-business-box {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-image: url("../assets/homeViewImg/m_b_bg.png");
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px 15px 50px; /* 缩减上下内边距（原47px/76px），小屏更紧凑；左右加防贴边内边距 */

  // 中文标题（主营业务）
  .title-box {
    font-weight: 700;
    font-size: 26px; /* 小屏缩小字体（原32px），避免换行 */
    color: #333;
    text-align: center; /* 确保小屏标题居中 */
  }

  // 英文副标题（Main Business）
  .text-box {
    font-weight: 700;
    font-size: 22px; /* 小屏缩小字体（原28px） */
    color: #999;
    margin: 8px 0 15px; /* 缩减间距（原10px/20px），小屏更紧凑 */
    font-family: AbhayaLibre-ExtraBold-2;
    text-align: center; /* 小屏英文标题居中，与中文标题呼应 */
  }

  // 业务图片列表容器（核心响应式布局）
  .ul-box {
    width: 100%;
    max-width: 1200px; /* 大屏限制最大宽度，匹配原设计 */
    height: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap; /* 自动换行，适配不同屏幕 */
    gap: 18px; /* 小屏缩减间距（原22px），避免拥挤 */
    padding: 0;
    margin: 0;
    list-style: none; /* 清除默认列表样式 */
  }

  // 业务图片项（单张图片容器）
  .li-box {
    flex: 1 1 100%; /* 小屏1列：弹性占满宽度，最小宽度100% */
    max-width: 385px; /* 限制最大宽度，避免大屏单张图片过宽（匹配原图片宽度） */
    padding: 0;
    margin: 0;

    // 业务图片
    img {
      width: 100%; /* 图片自适应容器宽度，取消固定宽度 */
      height: auto; /* 保持图片比例，避免拉伸变形 */
      max-height: 286px; /* 限制最大高度，匹配原设计 */
      object-fit: cover; /* 确保图片填充容器，不拉伸 */
      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* 保留原过渡效果 */
      border-radius: 6px; /* 小屏加圆角，提升质感（大屏可保留） */
    }

    // 图片hover缩放效果（保留原交互）
    img:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12); /* 增强hover阴影，提升交互感知 */
    }
  }

  // --------------------------
  // 中屏（768px-1199px）：2列布局，适配平板
  // --------------------------
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 40px 20px 60px; /* 增加内边距，比小屏宽松 */

    .title-box {
      font-size: 29px; /* 增大字体，接近原设计 */
    }

    .text-box {
      font-size: 25px; /* 增大字体，接近原设计 */
      margin: 9px 0 18px; /* 调整间距，接近原设计 */
    }

    .ul-box {
      gap: 20px; /* 增加间距，比小屏宽松（接近原22px） */
    }

    .li-box {
      flex: 1 1 calc(50% - 10px); /* 中屏2列：弹性占比，减去一半间距（避免溢出） */
      max-width: none; /* 取消最大宽度限制，适配中屏2列布局 */
    }
  }

  // --------------------------
  // 大屏（≥1200px）：3列布局，还原原设计
  // --------------------------
  @media (min-width: 1200px) {
    padding: 47px 0 76px; /* 恢复原内边距 */

    .title-box {
      font-size: 32px; /* 恢复原字体 */
    }

    .text-box {
      font-size: 28px; /* 恢复原字体 */
      margin: 10px 0 20px; /* 恢复原间距 */
    }

    .ul-box {
      gap: 22px; /* 恢复原间距 */
    }

    .li-box {
      flex: 1 1 calc((100% - 2 * 22px) / 3); /* 大屏3列：弹性占比，减去2倍间距（原计算逻辑） */
      max-width: none; /* 取消最大宽度限制，适配3列布局 */
    }

    img {
      max-height: 286px; /* 恢复原最大高度，确保3列图片等高 */
      border-radius: 6px; /* 保留圆角，提升大屏质感（若原设计无圆角可改为0） */
    }

    img:hover {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15); /* 大屏增强hover阴影，提升交互质感 */
    }
  }
}

.project-case-box {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-image: url("../assets/homeViewImg/project_case_bg.png");
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px 15px 50px; /* 小屏缩减内边距，避免拥挤；左右防贴边 */
  color: white;

  // 中文标题（工程案例）
  .title-box {
    font-weight: 700;
    font-size: 26px; /* 小屏缩小字体（原32px），避免换行 */
    text-align: center;
  }

  // 英文副标题（Qualification Certificate）
  .text-box {
    font-weight: 700;
    font-size: 22px; /* 小屏缩小字体（原28px） */
    margin: 8px 0 15px; /* 缩减间距（原10px/20px） */
    color: #d4d7da;
    font-family: AbhayaLibre-ExtraBold-2;
    text-align: center;
  }

  // 核心内容区（分类block1 + 图片block2 + 查看更多block3）
  .section-box {
    width: 100%;
    max-width: 1200px; /* 大屏限制最大宽度，匹配原设计 */
    height: auto; /* 取消固定高度，自适应内容 */
    display: flex;
    flex-direction: column; /* 小屏垂直排列（分类在上，图片+查看更多在下） */
    gap: 15px; /* 小屏模块间距，避免拥挤 */
  }

  // 分类区（左侧文字切换项）
  .block1 {
    width: 100%;
    max-width: 248px; /* 限制最大宽度，匹配原设计 */
    height: auto; /* 取消固定高度 */
    background-color: rgba(141, 138, 138, 0.2);
    font-size: 16px; /* 小屏缩小字体（原18px） */
    display: flex;
    flex-direction: row; /* 小屏横向排列，支持滚动 */
    overflow-x: auto; /* 小屏横向滚动，避免分类项换行 */
    align-items: center;
    border-radius: 8px; /* 小屏全圆角，提升质感 */
    box-sizing: border-box;
    padding: 5px 0; /* 小屏加上下内边距，避免贴边 */
    // overflow: hidden;

    // 隐藏横向滚动条（优化视觉）
    &::-webkit-scrollbar {
      height: 0;
    }

    // 分类切换项
    .text-item-box {
      min-width: 100px; /* 小屏限制最小宽度，避免过窄 */
      height: 60px; /* 缩减高度（原80px），小屏更紧凑 */
      padding: 0 15px; /* 调整内边距，适配小屏 */
      display: flex;
      align-items: center;
      justify-content: center; /* 小屏文字居中 */
      border-bottom: none; /* 小屏取消底部边框，横向无需分隔 */
      border-right: 1px solid #8d8a8a; /* 小屏加右侧边框，分隔分类项 */
      cursor: pointer;
      flex-shrink: 0; /* 禁止收缩，确保完整显示 */

      // 最后一项取消右侧边框
      &:last-child {
        // border-right: none;
        border: none;
      }

      // 激活状态样式
      &.is-active {
        background-color: #3755f7;
      }
    }
  }

  // 图片展示区（中间img直接循环，调整flex布局）
  .block2 {
    width: 100%;
    display: flex;
    flex-direction: column; /* 小屏垂直堆叠图片 */
    gap: 15px; /* 小屏图片间距，避免拥挤 */
    align-items: center; /* 小屏图片居中 */
    padding: 0;
    margin: 0;
  }

  // 图片项（直接作用于循环的img，无需嵌套容器）
  .img-item-box {
    width: 100%;
    max-width: 279px; /* 限制最大宽度，匹配原设计 */
    height: auto; /* 取消固定高度，自适应宽度 */
    max-height: 300px; /* 限制最大高度，避免小屏过高 */
    object-fit: cover; /* 确保图片填充容器，不拉伸 */
    border-radius: 4px; /* 小屏加圆角，提升质感 */
  }

  // 查看更多区（右侧纵向文字）
  .block3 {
    font-size: 14px; /* 小屏缩小字体（原16px） */
    width: 100%;
    max-width: 248px; /* 限制最大宽度，匹配分类区 */
    height: 50px; /* 小屏改为横向按钮高度 */
    background-color: rgba(141, 138, 138, 0.2);
    border-radius: 8px; /* 小屏全圆角 */
    display: flex;
    flex-direction: row; /* 小屏横向排列（文字+图标） */
    align-items: center;
    justify-content: center; /* 小屏内容居中 */
    cursor: pointer;
    margin: 0 auto; /* 小屏居中，提升平衡感 */

    span {
      writing-mode: horizontal-tb; /* 小屏取消纵向文字，改为横向 */
      letter-spacing: 2px; /* 缩减字间距（原8px），适配横向 */
      // margin-right: 8px; /* 文字与图标间距 */
    }

    img {
      width: 16px; /* 小屏缩小图标（原18px） */
      height: 16px;
    }
  }

  @media (max-width: 768px) {
    .block1 {
      max-width: none;
    }

    .block3 {
      max-width: 278px !important;
    }
  }

  @media (min-width: 768px) and (max-width: 980px) {
    .block3 {
      flex: 1 !important;
    }
  }

  @media (min-width: 768px) and (max-width: 841px) {
    .block3 {
      display: none;
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 40px 20px 60px; /* 增加内边距，比小屏宽松 */

    .title-box {
      font-size: 29px; /* 增大字体，接近原设计 */
    }

    .text-box {
      font-size: 25px; /* 增大字体，接近原设计 */
      margin: 9px 0 18px; /* 调整间距，接近原设计 */
    }

    .section-box {
      flex-direction: row; /* 中屏横向排列（分类区单行，图片+查看更多一列） */
      flex-wrap: wrap; /* 避免极端中屏溢出 */
      gap: 15px;
    }

    // 分类区调整
    .block1 {
      flex: 1 1 100%; /* 分类区占满宽度，单独一行 */
      flex-direction: row; /* 保持横向滚动 */
      max-width: none;
      font-size: 17px; /* 增大字体，接近原设计 */

      .text-item-box {
        min-width: 120px; /* 增大分类项最小宽度 */
        height: 70px; /* 增大高度，接近原设计 */
        padding: 0 20px;
      }
    }

    // 图片区调整（横向排列）
    .block2 {
      flex: 1 1 calc(80% - 10px); /* 图片区占80%宽度 */
      flex-direction: row; /* 中屏图片横向排列 */
      justify-content: center;
      gap: 10px; /* 恢复原图片间距 */
      align-items: stretch; /* 中屏图片高度对齐 */
      justify-content: space-between;
    }

    .img-item-box {
      max-width: 279px; /* 恢复原图片宽度 */
      max-height: 350px; /* 增大最大高度，适配中屏 */
      height: 100%; /* 中屏图片高度与容器一致 */
    }

    // 查看更多区调整（纵向布局）
    .block3 {
      flex: 1 1 calc(20% - 10px); /* 查看更多区占20%宽度 */
      max-width: none;
      // height: 100%; /* 中屏高度与图片区一致 */
      height: 350px; /* 中屏高度与图片区一致 */
      flex-direction: column; /* 恢复纵向布局 */
      border-radius: 0 8px 8px 0; /* 恢复右侧圆角 */
      margin: 0;

      span {
        writing-mode: vertical-rl; /* 恢复纵向文字 */
        letter-spacing: 6px; /* 调整字间距，接近原设计 */
        margin-right: 0;
        margin-bottom: 8px; /* 文字与图标间距 */
      }

      img {
        width: 18px; /* 恢复原图标尺寸 */
        height: 18px;
        transform: rotate(90deg); /* 图标旋转90度，适配纵向 */
      }
    }
  }

  @media (min-width: 1200px) {
    padding: 47px 0 76px; /* 恢复原内边距 */

    .title-box {
      font-size: 32px; /* 恢复原字体 */
    }

    .text-box {
      font-size: 28px; /* 恢复原字体 */
      margin: 10px 0 20px; /* 恢复原间距 */
    }

    .section-box {
      flex-direction: row; /* 大屏三栏横向排列 */
      justify-content: space-between; /* 两端对齐，匹配原设计 */
      height: 400px; /* 恢复原固定高度 */
      gap: 0; /* 清除间距，恢复原设计 */
    }

    // 分类区还原
    .block1 {
      width: 248px; /* 恢复原固定宽度 */
      height: 100%; /* 恢复原高度 */
      flex-direction: column; /* 恢复垂直排列分类项 */
      overflow-x: visible; /* 清除横向滚动 */
      border-radius: 8px 0 0 8px; /* 恢复左侧圆角 */
      padding: 0;
      overflow: hidden;

      .text-item-box {
        min-width: auto; /* 清除最小宽度限制 */
        width: 100%; /* 分类项占满宽度 */
        height: 80px; /* 恢复原高度 */
        padding: 0 26px; /* 恢复原内边距 */
        justify-content: flex-start; /* 恢复文字左对齐 */
        border-bottom: 1px solid #8d8a8a; /* 恢复底部边框 */
        border-right: none; /* 清除右侧边框 */
      }
    }

    // 图片区还原（横向排列，高度对齐）
    .block2 {
      flex: 1; /* 图片区弹性占比，匹配原设计 */
      flex-direction: row; /* 恢复横向排列 */
      justify-content: space-between; /* 恢复两端对齐 */
      gap: 10px; /* 恢复原图片间距 */
      align-items: stretch; /* 图片高度与容器一致 */
      // margin: 0 6px; /* 恢复原左右margin */
      margin: 0 10px;
    }

    .img-item-box {
      width: 279px; /* 恢复原固定宽度 */
      height: 100%; /* 恢复原高度，与容器等高 */
      max-height: none; /* 清除最大高度限制 */
      border-radius: 0; /* 恢复原无圆角 */
    }

    // 查看更多区还原
    .block3 {
      width: 69px; /* 恢复原固定宽度 */
      height: 100%; /* 恢复原高度 */
      border-radius: 0 8px 8px 0; /* 恢复右侧圆角 */
      flex-direction: column; /* 恢复纵向布局 */
      font-size: 16px; /* 恢复原字体 */
      margin: 0;

      span {
        writing-mode: vertical-rl; /* 恢复纵向文字 */
        letter-spacing: 8px; /* 恢复原字间距 */
        margin-bottom: 10px; /* 恢复原间距 */
      }

      img {
        width: 18px; /* 恢复原图标尺寸 */
        height: 18px;
        transform: none; /* 清除旋转，恢复原方向 */
      }
    }
  }
}

.course-box {
  width: 100%;
  height: auto; /* 取消固定高度，自适应内容+背景展示需求 */
  min-height: 400px; /* 小屏设置最小高度，避免背景过矮 */
  max-height: 684px; /* 大屏限制最大高度，还原原设计 */
  margin: 0 auto;
  background-image: url("../assets/homeViewImg/course_img.png");
  background-size: cover; /* 背景图自适应，不拉伸 */
  background-position: center;
  background-repeat: no-repeat; /* 避免背景图重复 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* 标题从顶部排列 */
  padding: 40px 15px; /* 小屏上下内边距，左右防贴边 */
  box-sizing: border-box;

  // 中文标题（发展历程）
  .title-box {
    font-weight: 700;
    font-size: 26px; /* 小屏缩小字体，避免换行 */
    margin: 0 0 10px; /* 取消顶部margin，父容器padding控间距 */
    color: #333;
    text-align: center; /* 小屏标题居中，强化焦点 */
  }

  // 英文副标题（Development History）
  .text-box {
    color: #999;
    font-size: 22px; /* 小屏缩小字体，与中文标题比例协调 */
    font-family: AbhayaLibre-ExtraBold-2;
    text-align: center; /* 小屏副标题居中，呼应标题 */
  }

  // --------------------------
  // 中屏（768px-1199px）：适配平板
  // --------------------------
  @media (min-width: 768px) and (max-width: 1199px) {
    min-height: 500px; /* 中屏增大最小高度，适配平板比例 */
    max-height: 620px; /* 限制最大高度，避免超出屏幕 */
    padding: 45px 20px; /* 增加内边距，比小屏宽松 */

    .title-box {
      font-size: 29px; /* 增大字体，接近原设计 */
      margin: 0 0 11px; /* 微调间距，保持比例 */
    }

    .text-box {
      font-size: 25px; /* 增大字体，接近原设计 */
    }
  }

  // --------------------------
  // 大屏（≥1200px）：还原原设计
  // --------------------------
  @media (min-width: 1200px) {
    height: 684px; /* 恢复原固定高度 */
    min-height: auto; /* 清除最小高度限制 */
    max-height: none; /* 清除最大高度限制 */
    padding: 0; /* 清除内边距，还原原设计 */
    justify-content: flex-start; /* 保持标题顶部排列 */

    .title-box {
      font-size: 32px; /* 恢复原字体 */
      margin: 50px 0 12px; /* 恢复原margin，匹配原视觉位置 */
    }

    .text-box {
      font-size: 28px; /* 恢复原字体 */
    }
  }
}

.certificate-box {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-image: url("../assets/homeViewImg/certificate_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 15px 50px;
  box-sizing: border-box;

  // 中文标题（资质证书）
  .title-box {
    font-weight: 700;
    font-size: 26px; /* 小屏缩小字体 */
    margin: 0 0 10px;
    color: #333;
    text-align: center;
  }

  // 英文副标题（Qualification Certificate）
  .text-box {
    color: #999;
    font-size: 22px; /* 小屏缩小字体 */
    font-family: AbhayaLibre-ExtraBold-2;
    text-align: center;
    margin-bottom: 15px;
  }

  // 证书列表容器（核心响应式布局）
  .ul-box {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column; /* 小屏1列垂直排列 */
    align-items: center;
    gap: 30px; /* 小屏证书间距 */
    padding: 0;
    margin: 0;
    list-style: none;

    // 单个证书项（图片+文字）
    .li-box {
      width: 100%;
      max-width: 280px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 15px; /* 图片与文字间距 */

      // 证书图片（关键：用aspect-ratio保持高度一致）
      .img-block {
        width: 100%;
        max-width: 140px;
        // 固定宽高比（原160px/244px ≈ 0.655），确保所有图片高度一致
        aspect-ratio: 160 / 244; 
        object-fit: cover; /* 配合el-image的fit="cover"，避免拉伸 */
        margin: 0;
        border-radius: 4px;
        box-shadow: 0 3px 8px rgba(0,0,0,0.08);
      }

      // 证书文字标签
      span {
        width: 100%;
        // max-width: 250px;
        line-height: 50px; /* 小屏缩减行高 */
        background: #3755f7;
        border-radius: 50px;
        font-size: 18px; /* 小屏缩小字体 */
        color: white;
        text-align: center;
        white-space: nowrap; /* 文字不换行 */
        overflow: hidden;
        text-overflow: ellipsis; /* 溢出显示省略号 */
      }

      @media (max-width: 768px) {
        span {
          max-width: 250px;
        }
      }
    }
  }

  // --------------------------
  // 中屏（768px-1199px）：2列布局
  // --------------------------
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 40px 20px 60px;

    .title-box {
      font-size: 29px; /* 增大字体 */
      margin: 0 0 11px;
    }

    .text-box {
      font-size: 25px; /* 增大字体 */
      margin-bottom: 20px;
    }

    .ul-box {
      flex-direction: row; /* 中屏2列横向排列 */
      flex-wrap: wrap; /* 自动换行防溢出 */
      justify-content: center;
      gap: 40px; /* 中屏证书间距 */

      .li-box {
        max-width: 320px;
        gap: 18px; /* 调整图片与文字间距 */

        .img-block {
          max-width: 150px;
          // 保持原宽高比，确保中屏图片高度一致
          aspect-ratio: 160 / 244; 
          max-height: none;
        }

        span {
          max-width: 270px;
          line-height: 58px; /* 增大行高 */
          font-size: 22px; /* 增大字体 */
        }
      }
    }
  }

  // --------------------------
  // 大屏（≥1200px）：3列布局，还原原设计
  // --------------------------
  @media (min-width: 1200px) {
    padding: 50px 0 76px;

    .title-box {
      font-size: 32px; /* 恢复原字体 */
      margin: 0 0 12px;
    }

    .text-box {
      font-size: 28px; /* 恢复原字体 */
      margin-bottom: 0;
    }

    .ul-box {
      flex-direction: row; /* 大屏3列横向排列 */
      justify-content: space-between;
      // gap: 170px; /* 恢复原间距 */
      flex-wrap: nowrap;

      .li-box {
        max-width: none;
        gap: 22px; /* 恢复原间距 */

        .img-block {
          width: 160px; /* 恢复原固定宽度 */
          // 保持原宽高比，确保大屏图片高度一致（244px）
          aspect-ratio: 160 / 244; 
          max-width: none;
          border-radius: 0;
          box-shadow: none;
          margin: 30px 0 22px; /* 恢复原margin */
        }

        span {
          width: 240px; /* 恢复原固定宽度 */
          // line-height: 64px; /* 恢复原行高 */
          font-size: 22px; /* 恢复原字体 */
          white-space: normal;
          overflow: visible;
          text-overflow: clip;
        }
      }
    }
  }
}


.flex-between {
  display: flex;
  justify-content: space-between;
}

.xs-business-content {
  position: relative;
  width: 100vw;
  height: auto;

  .xs-business-area {
    width: 100vw;
    background-color: transparent;
    background-image: url(@/assets/bAreaBg2.jpg);
    background-repeat: no-repeat;
    background: -moz-linear-gradient(top, none, none);
    background: -o-linear-gradient(top, none, none);
    // background: linear-gradient(top, none, none);
	background: linear-gradient(to bottom, none, none);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(none),
      to(none)
    );
    background-size: cover;

    z-index: 1;

    .xs-item-container {
      position: relative;
      z-index: 1;

      width: 100vw;
      //height: 100%;

      overflow: hidden;

      .xs-item {
        padding: 0 20px 18px 20px;
        color: white;
        //display: inline-block;
        text-align: left;
        width: 100%;
        height: 25%;
        border-bottom: 1px solid #8f8f8f;
        //line-height: 10rem;
        font-family: Source Han Sans;

        .more-button {
          margin-top: 5px;
        }

        img {
          width: 49px;
          height: 49px;
          margin-top: 15px;
        }

        .m-title {
          margin-top: 5px;
          font-size: 30px;
        }

        .s-title {
          width: 50%;
          font-size: 14px;
        }
      }
    }
  }
}

.xs-carousel-title {
  position: relative;
  top: 30px;
  font-size: 2.5rem;
  font-weight: 300;
  opacity: 0.9;
}

.xs-carousel-subtitle {
  position: relative;
  top: 30px;
  font-family: Microsoft YaHei;
  letter-spacing: 1.2px;
  font-size: 1.1rem;
  font-weight: 300;
  opacity: 0.7;
}

@media screen and (min-width: 992px) {
  .about-text {
    width: 1000px;
    background: white;
  }
}

@media screen and (max-width: 768px) {
  .carousel-text {
    top: 60px !important;
  }

  .about-text {
    padding-left: 10px;
    padding-right: 10px;
    width: 98vw;
  }
  .project {
    margin-top: 42vh;
    position: relative;

    .project-content {
      .item {
        position: relative;
        margin-bottom: 10px;

        .img-container {
          width: 94vw !important;
          margin-left: 3vw;
        }

        .project-name {
          width: 100vw !important;
        }
      }
    }
  }
  .carText-con {
    font-size: 1.5rem !important;
  }
  .area-title {
    margin-top: 70px !important;
  }
  .area-subtitle {
    font-size: 2rem !important;
  }
  .area_img {
    flex-direction: column;
    width: 596px !important;
    height: 540px !important;

    img {
      width: 596px !important;
      height: 260px !important;
    }
  }
  .bg-f7 {
    height: 900px !important;
  }
}

.about-text {
  font-size: 16px;
  margin: 0 auto;

  line-height: 28px;
  text-indent: 32px;
}

.project {
  padding-top: 180px;

  .project-content {
    width: 100%;
    min-width: 1200px;
    margin-top: 30px;

    .item {
      .img-container {
        width: 390px;
        overflow: hidden;

        img {
          width: auto;
          height: 290px;
        }
      }

      //background: red;
      //width: 435px;
      height: 330px;
      overflow: hidden;

      .project-name {
        margin-top: 10px;

        text-align: center;
        font-size: 22px;
        width: 390px;
        max-width: 390px;

        font-family: "Source Han Sans";
      }
    }
  }
}

.area-title h2:after {
  content: "";
  margin: 10px auto;
  display: block;
  width: 100px;
  height: 3px;
  background: #dcdcdc;
}

.area-title {
  h2 {
    font-size: 46px !important;
  }

  .carSubtitle {
    font-size: 28px;
  }

  text-align: center;
  position: relative;
  top: -20px;
  margin-bottom: 50px;
}

.area_img {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1600px;
  overflow: hidden;
  margin: 0 auto;

  img {
    width: 796px;
    height: 360px;
  }
}

.item-container {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  width: 1080px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  overflow: hidden;

  .item {
    cursor: pointer;
    padding: 0 20px 0 20px;
    color: white;
    //display: inline-block;
    text-align: left;
    display: flex;
    justify-content: center;
    width: 50%;
    height: 100%;
    border-right: 1px solid #8f8f8f;
    line-height: 1.75;
    font-family: Source Han Sans;

    .item-content:hover {
      transform: translateY(-10px);
      transition: transform 0.3s;
    }

    .item-content {
      width: 270px;
      margin-top: 120px;
      transition: transform 0.3s;

      .more-button {
        margin-top: 50px;
      }

      img {
        width: 59px;
        height: 59px;
        margin-bottom: 10px;
      }

      .m-title {
        font-size: 30px;
      }

      .s-title {
        font-size: 14px;
      }
    }
  }
}
</style>
